/**
*
* @Description: 打印工具
* @method OPrinter

* @return
* @author liumingquan

* @author ecolouds-01
* @date 2016年12月15日 下午5:16:02
使用帮助使用前，必须先初始化 打印组件：ng-init="$root.OPrinter.init()"
  关键步骤：
  1.初始化打印组件。
  2.调用打印，预览等功能。

*/
import LodopFuncs1 from './LodopFuncs_amd'
function lodopUtils() {
  var LodopFuncs = null
  var LODOP = null
  function getOPrinter() {
    if (!LODOP && LodopFuncs) {
      LODOP = LodopFuncs.getLodop()
      LODOP.SET_LICENSES('四川盘谷智慧医疗科技有限公司', '160CB03308929656138B8125A87D070B', '', '')
    }
    return LODOP
  } //_getLODOP

  /**
   *
  * @Description: 打印工具 初始化
  * @method OPrinter

  * @return
  * @author liumingquan

  * @author ecolouds-01
  * @date 2016年12月15日 下午5:16:02
  打印页边距设定为 0mm 时，网页内最大元素的分辨率：794×1123
  <div style="width:794px;height:1123px;border:1px solid #000000;"> </div>

  打印页边距设定为 5mm 时，网页内最大元素的分辨率：756×1086
  <div style="width:756px;height:1086px;border:1px solid #000000;"> </div>

  打印页边距设定为 19.05mm 时，网页内最大元素的分辨率：649×978
  <div style="width:649px;height:978px;border:1px solid #000000;"> </div>

  */
  var OPrinter = {
    LODOP: null, //返回具体打印的实现累，用于特殊需求打印。

    print_param_defualt: {
      print_orient: 0, //打印方向及纸张类型，数字型.1---纵(正)向打印，固定纸张；
      paper_top: 0, //整页上边距，整数或字符型
      paper_left: 0, //整页左边距
      paper_width: 2100, //可视编辑区域的宽度.A4 21*29.7cm（210mm×297mm）
      paper_height: 2970, //可视编辑区域的高度
      html_top: 0, //html上边距，整数或字符型
      html_left: 0, //html上边距，整数或字符型
      html_width: '100%', //html的宽度
      html_height: '100%', //html上边距，整数或字符型
    },

    print_param: null,

    //设定纸张大小
    _pageSize: {
      intOrient: 1,
      intPageWidth: 2160,
      intPageHeight: 1400,
    },
    /**
     *
    * @Description: 打印工具 初始化
    * @method OPrinter

    * @return
    * @author liumingquan

    * @author ecolouds-01
    * @date 2016年12月15日 下午5:16:02
      使用帮助使用前，必须先初始化 打印组件：ng-init="$root.OPrinter.init()"
        关键步骤：
        1.初始化打印组件。
        2.调用打印，预览等功能。

        PRINT_INIT(strPrintTaskName)打印初始化
        ●	SET_PRINT_PAGESIZE(intOrient,intPageWidth,intPageHeight,strPageName)设定纸张大小
        ●	ADD_PRINT_HTM(intTop,intLeft,intWidth,intHeight,strHtml)增加超文本项
        ●	ADD_PRINT_TEXT(intTop,intLeft,intWidth,intHeight,strContent)增加纯文本项
        ●	ADD_PRINT_TABLE(intTop,intLeft,intWidth,intHeight,strHtml)增加表格项
        ●	ADD_PRINT_SHAPE(intShapeType,intTop,intLeft,intWidth,intHeight,intLineStyle,intLineWidth,intColor)画图形
        ●	SET_PRINT_STYLE(strStyleName, varStyleValue)设置对象风格
        ●	PREVIEW打印预览
        ●	PRINT直接打印
        ●	PRINT_SETUP打印维护
     */
    init: function (callbackData, callback) {
      //如果init和setPrint_paramByUICustomHtml 调用顺序不确定时，修复如果init和setPrint_paramByUICustomHtml 设置失败bug。
      if (!this.print_param) {
        //只初始化一次
        this.print_param = Object.assign({}, this.print_param_defualt)
      }
      if (!LODOP) {
        LodopFuncs = LodopFuncs1
        //异步加载js
        LodopFuncs1.loadCLodop(function () {
          setTimeout(() => {
            if (callback) callback()
          }, 500)
          // if (callback) callback()
        })
        window.setTimeout(function () {
          if (callbackData) {
            callbackData.defaultPrinterName = OPrinter.getPrinterName(-1)
            // if ($scope) $scope.$digest();
          }
        }, 1000)
      } else {
        if (callback) callback()
      }
    },
    //获得打印机个数
    getPrinterCount: function () {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }

      return LODOP.GET_PRINTER_COUNT()
    },
    //用序号获得打印机名，一般序号从0开始，-1特指默认打印机；
    getPrinterName: function (intPrinterIndex) {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }

      return LODOP.GET_PRINTER_NAME(intPrinterIndex)
    },
    //用序号获得打印机名，一般序号从0开始，-1特指默认打印机；
    selectAsDefaultPrinter: function (callbackData) {
      var On_Return = function (TaskID, Value) {
        if (Value >= 0) {
          if (callbackData) {
            callbackData.defaultPrinterName = OPrinter.getPrinterName(Value)
            // if ($scope) $scope.$digest();
          }
        } else {
          alert('选择失败！')
        }
      }

      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }

      if (LODOP.CVERSION) {
        LODOP.On_Return = On_Return
        LODOP.SELECT_PRINTER()
        return
      }
      var On_ReturnValue = LODOP.SELECT_PRINTER()
      On_Return(null, On_ReturnValue)
    },

    chkOPrinter: function () {
      return window.getCLodop ? true : false
    },

    // 页面方法，检测是否注册，若没有注册则运行注册流程
    regLicenses: function () {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
      } else {
        LODOP.SET_LICENSES(
          '四川盘谷智慧医疗科技有限公司',
          '160CB03308929656138B8125A87D070B',
          '',
          ''
        )
      }
    },

    //设置打印参数,根据接口返回html模版数据
    setPrint_paramByUICustomHtml: function (uICustomHtml) {
      //  console.log("setPrint_paramByUICustomHtml",uICustomHtml);
      if (!uICustomHtml) return
      var p = Object.assign({}, this.print_param_defualt)
      for (var key in p) {
        if (uICustomHtml[key]) {
          p[key] = uICustomHtml[key]
          console.log('key', key, uICustomHtml[key])
        }
      }

      // console.log(p);
      this.print_param = p
    },
    //获取打印机列表
    getPrinters() {
      const tatol = this.getPrinterCount()
      const list = []
      for (let i = 0; i < tatol; i++) {
        list.push({
          value: i,
          label: this.getPrinterName(i),
        })
      }
      return list
    },
    //设置打印机
    setPrinterIndex(index) {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }
      LODOP.SET_PRINTER_INDEX(index)
    },

    //设置打印尺寸
    setRect: function (intTop, intLeft, intWidth, intHeight) {
      this.print_param.html_top = intTop
      this.print_param.html_left = intLeft
      this.print_param.html_width = intWidth
      this.print_param.html_height = intHeight
    },

    _PrintDivId: null,
    //设置打印的内容是htmlid绑定的innerHTML。优先级高于_PrintHtml
    setPrintDivId: function (divId) {
      this._PrintDivId = divId
    },
    _PrintHtml: null,
    //设置打印的内容innerHTML
    setPrintHtmlContent: function (content) {
      this._PrintHtml = content
    },
    //返回要打印的内容
    getPrintHtmlContent: function () {
      if (this._PrintDivId) this._PrintHtml = document.getElementById(this._PrintDivId).innerHTML
      return this._PrintHtml
    },

    //打印前的准备工作。设置打印参数，及打印内容
    _printBeforePrint: function (taskName) {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }
      // 若strTaskName空，控件则不保存本地化信息，打印全部由页面程序控制。

      if (!taskName) taskName = ''
      // (扩展型)打印初始化
      // 格式：PRINT_INITA(Top,Left,Width,Height,strPrintName)
      // 功能：打印初始化、设定纸张整体偏移量、设定可视编辑区域大小
      var p = this.print_param

      LODOP.PRINT_INITA(p.paper_top, p.paper_left, p.paper_width, p.paper_height, taskName)

      // LODOP.ADD_PRINT_BARCODE(5,500,280,50,"128Auto","GYSFY201807427CLC");
      // LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0)
      //必须在格式：PRINT_INITA 后面才生效。
      LODOP.SET_PRINT_PAGESIZE(p.print_orient, p.paper_width, p.paper_height, taskName)
      // LODOP.ADD_PRINT_HTM(this._rect.top,this._rect.left,this._rect.width,this._rect.height,content);

      return LODOP
    },
    addContent: function (content, newPage) {
      if (!LODOP) {
        LODOP = getOPrinter()
        // this.LODOP = LODOP;
        if (!LODOP) console.log('need exe:$root.OPrinter.init()')
      }
      if (!content) content = this.getPrintHtmlContent()
      //解决不同浏览器预览模式，显示不一样的bug。需要打印html前缀需要增加：<!DOCTYPE html>
      content = '<!DOCTYPE html>' + content
      //设定纸张大小
      // LODOP.SET_PRINT_PAGESIZE(intOrient,intPageWidth,intPageHeight,strPageName)
      //●	ADD_PRINT_HTM(intTop,intLeft,intWidth,intHeight,strHtml)增加超文本项
      if (newPage) {
        LODOP.NewPageA()
      }
      var p = this.print_param
      let tableArr = content.match(/<\/table>/g)
      // 如果只有一个table，默认表示是支持分页，就用ADD_PRINT_TABLE，否则用ADD_PRINT_HTM解决只用ADD_PRINT_TABLE会导致有多个table时只显示第一个查找到的table的内容的bug。
      if (tableArr && tableArr.length == 1) {
        // 为满足分页打印而加的。
        LODOP.ADD_PRINT_TABLE(
          p.html_top,
          p.html_left,
          `RightMargin: ${p.html_width}`,
          `BottomMargin: ${p.html_height}`,
          content
        )
        //将模板打印出来，方便排查错误
        console.error('LODOP.ADD_PRINT_TABLE.content', content)
      } else {
        LODOP.ADD_PRINT_HTM(
          p.html_top,
          p.html_left,
          `RightMargin: ${p.html_width}`,
          `BottomMargin: ${p.html_height}`,
          content
        )
        //将模板打印出来，方便排查错误
        console.error('LODOP.ADD_PRINT_HTM.content', content)
      }
    },
    preview: function () {
      // LODOP = this._printBeforePrint(content, taskName);
      LODOP.PREVIEW()
    }, //preview
    allPage: function () {
      LODOP.ADD_PRINT_HTM(
        this.print_param.html_top,
        this.print_param.html_left,
        `RightMargin: ${this.print_param.html_width}`,
        100,
        "<p style='font-size: 6pt;text-align:right;'>第<font tdata='PageNO' color='blue'>##</font>页/共<font tdata='PageCount' color='blue'>##</font>页</p>"
      )
      LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1)
    },
    //打印
    print: function (num) {
      // LODOP = this._printBeforePrint(content, taskName);
      LODOP.SET_PRINT_COPIES(num) // 设置打印份数
      LODOP.SET_PRINT_MODE('RESELECT_COPIES', true) // 设置可继续修改打印份数
      LODOP.PRINT()
    }, //print

    //打印设置。整体位置调整。
    printSetup: function (content, taskName) {
      LODOP = this._printBeforePrint(content, taskName)
      LODOP.PRINT_SETUP()
    }, //print

    //打印设置。详细调整，可以到每个字
    printDesign: function (content, taskName) {
      LODOP = this._printBeforePrint(content, taskName)
      LODOP.PRINT_DESIGN()
    }, //print

    //设置基本打印风格
    setPrintStyle: function (key, val) {
      LODOP = getOPrinter()
      // LODOP.SET_PRINT_STYLE("FontSize",11);
      LODOP.SET_PRINT_STYLE(key, val)
    }, //preview

    // 设置打印份数
    setPrintNum: function (num) {
      // LODOP = this._printBeforePrint(content, taskName);
      LODOP.SET_PRINT_COPIES(num) // 设置打印份数
      LODOP.SET_PRINT_MODE('RESELECT_COPIES', true) // 设置可继续修改打印份数
    },
  } //OPrinter

  return OPrinter
}

export { lodopUtils }
